
export default {
  setLogLengths (state, logLengths) {
    state.logLengths = logLengths
  },

  setLengthGroups (state, { lengthGroups, accountId }) {
    state.accountIdOfLengthGroups = accountId
    state.lengthGroups = lengthGroups
  },

  setDiameterGroups (state, { diameterGroups, accountId }) {
    state.accountIdOfDiameterGroups = accountId
    state.diameterGroups = diameterGroups
  },

  setSpeciesGroups (state, speciesGroups) {
    state.speciesGroups = speciesGroups
  }
}
